import { render, staticRenderFns } from "./ProviderLogStat.vue?vue&type=template&id=552a1188&scoped=true&"
import script from "./ProviderLogStat.vue?vue&type=script&lang=js&"
export * from "./ProviderLogStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a1188",
  null
  
)

export default component.exports